module.exports = __webpack_public_path__ + "static/bg-ctr.3e2b3856.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/network/bg-ctr.png
// module id = 242
// module chunks = 0